namespace Roodik.Core
{
	import Sound = PIXI.sound.Sound;
	
	export class SoundSettings
	{
		soundOn : boolean = true;
		musicOn : boolean = true;
	}

	export class SoundManager implements ISoundManager
	{
		private _music: PIXI.sound.Sound;
		private _soundSettings:SoundSettings;
		private readonly _sounds : Sound[];
		private _baseUrl:string="";

		constructor(private _storageManager:IStorageManager)
		{
			this._baseUrl = (window["cdnUrl"] == null || window["cdnUrl"] == undefined) ? "" : window["cdnUrl"];

			let ss = this._storageManager.loadData("sound-settings");
			this._soundSettings = ss ? JSON.parse(ss) : new SoundSettings();
			if (!this._soundSettings.soundOn)
			{
				this.muteSound();
			}
			if (!this._soundSettings.musicOn)
			{
				this.muteMusic();
			}
		}
		
		private save()
		{
			this._storageManager.saveData("sound-settings", JSON.stringify(this._soundSettings));
		}

		public playSound(fileName:string, volume:number = 1)
		{
			if (this.soundIsOn)
			{
				const sound = PIXI.sound.Sound.from(this._baseUrl+'resources/sounds/'+fileName);
				sound.loop = false;
				sound.singleInstance = true;
				sound.volume = volume;
				sound.play();
				/*if(this._sounds.indexOf(sound) == -1)
				{
					this._sounds.push(sound);
					console.log(this._sounds);
				}*/
			}
		}

		public playMusic(fileName:string, volume:number = 1)
		{
			if (this.musicIsOn && this._music == null)
			{
				this._music = PIXI.sound.Sound.from(this._baseUrl+'resources/sounds/'+fileName);
				this._music.loop = true;
				this._music.singleInstance = true;
				this._music.volume = volume;
				this._music.play();
			}
		}

		public stopMusic()
		{
			if (this._music != null)
			{
				this._music.stop();
				this._music.destroy();
				this._music = null;
			}
		}

		public unMuteSound()
		{
			this._soundSettings.soundOn = true;
			this.save();
		}

		public muteSound()
		{
			this._soundSettings.soundOn = false;
			this.save();
		}

		public unMuteMusic()
		{
			this._soundSettings.musicOn = true;
			this.save();

			this.playMusic("music.mp3", 0.3);
		}

		public muteMusic()
		{
			this._soundSettings.musicOn = false;
			this.save();

			this.stopMusic();
		}
		
		public windowFocusChanged(haveToMuteSounds:boolean)
		{
			if (haveToMuteSounds)
			{
				PIXI.sound.pauseAll();
			}
			else
			{
				PIXI.sound.resumeAll();
			}
			
			/*if (this._soundSettings.soundOn)
			{
			
			}
			
			if (this._soundSettings.musicOn)
			{
				if (this._music != null)
				{
					this._music.volume = haveToMuteSounds ? 0 : 0.3;
				}
			}*/
		}

		public get soundIsOn():boolean{return this._soundSettings.soundOn;}
		public get musicIsOn():boolean{return this._soundSettings.musicOn;}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Sound/SoundManager.ts